import React from 'react';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { PROFILE_DEFAULT } from '@/utils/enum';
import { useApplicationContext } from '@/context/v1/Application/context';
import kinebotLogo from '@/assets/img/logo.png';

import * as S from './styles';

interface HeaderType {
	title: string;
}

export function HeaderResult({ title }: Readonly<HeaderType>): JSX.Element {
	const { organization, company } = useApplicationContext();

	const companyLogo = company?.url_logo !== PROFILE_DEFAULT.URL ? company?.url_logo : undefined;
	const profileLogo = companyLogo ?? organization?.url_logo;

	return (
		<S.HeaderContainer>
			<Col span={6}>
				<S.ImageStyled src={kinebotLogo} preview={false} />
			</Col>
			<Col span={12}>
				<S.HeaderTitle>{I18n.get('Result')}</S.HeaderTitle>
				<S.HeaderSubTitle>{I18n.get(title)}</S.HeaderSubTitle>
			</Col>
			<Col span={6} style={{ display: 'flex', justifyContent: 'end' }}>
				<S.ImageStyled src={profileLogo || PROFILE_DEFAULT.URL} preview={false} />
			</Col>
		</S.HeaderContainer>
	);
}
